import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function HighlightedBadge({
  primaryColor,
  textPrimaryColor,
}: {
  primaryColor?: string | null;
  textPrimaryColor?: string | null;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      alignItems="center"
      bgcolor={primaryColor || '#C2E4BF'}
      border={primaryColor ? `1px solid ${primaryColor}` : undefined}
      borderRadius="16px"
      display="flex"
      gap={0.5}
      paddingX={1}
      paddingY={0.5}
    >
      <Typography
        color={textPrimaryColor || '#1B6515'}
        fontSize={10}
        fontStyle="normal"
        fontWeight={400}
        lineHeight="normal"
      >
        {t('companies.navigation.highlighted_badge')}
      </Typography>
    </Box>
  );
}
